/**
=========================================================
* Soft UI Dashboard React - v3.1.0
=========================================================

* Product Page: https://www.creative-tim.com/product/soft-ui-dashboard-pro-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Soft UI Dashboard React base styles
import colors from "@/theme/base/colors";
import typography from "@/theme/base/typography";

// Soft UI Dashboard React helper functions
import pxToRem from "@/theme/functions/pxToRem";

const { dark } = colors;
const { size, fontWeightBold, fontWeightRegular } = typography;

const formControlLabel = {
  styleOverrides: {
    root: {
      display: "block",
      // minHeight: pxToRem(24),
      // marginBottom: pxToRem(2),
    },

    label: {
      display: "inline-block",
      fontSize: size.sm,
      fontWeight: fontWeightRegular, //fontWeightBold,
      // color: dark.main,
      // lineHeight: 1,
      transform: `translateY(${pxToRem(1)})`,
      marginLeft: pxToRem(4),

      "&.Mui-disabled": {
        color: dark.main,
      },
    },
  },
};

export default formControlLabel;
